import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { svcMessages } from 'shared/app/messages';

import ManageCardImageLink from '../manage-card-image-link';
import ManageCardLink from '../manage-card-link';

const SvcCardSimple = (props) => {
  const {
    card: { balance, cardImageUrl, cardId, nickname },
    intl: { formatMessage, formatNumber, formats },
  } = props;

  const balanceFormatted = formatNumber(balance.amount, formats.number.money);
  const cardNicknameBalanceFormatted = formatMessage(
    svcMessages.cardNicknameBalance,
    { nickname, balance: balanceFormatted }
  );

  return (
    <div>
      <ManageCardImageLink
        cardId={cardId}
        cardImageUrl={cardImageUrl}
        cardNickname={nickname}
      />
      <div className="flex flex-wrap items-baseline pb2 mt2">
        <span className="hiddenVisually">{cardNicknameBalanceFormatted}</span>
        <span aria-hidden data-e2e="cardBalance">
          {balanceFormatted}
        </span>
        <span className="ml2 text-right flex-grow">
          <ManageCardLink
            aria-label={formatMessage(svcMessages.cardNicknameManageLink, {
              nickname,
            })}
            cardId={cardId}
          />
        </span>
      </div>
    </div>
  );
};

SvcCardSimple.propTypes = {
  card: PropTypes.object.isRequired,
};

export default injectIntl(SvcCardSimple);
